import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { useAppContext } from '@contexts/app';
import { PanelDropdownRespSuccess } from '../types';
import { usePanel } from '@hooks/usePanel';

export const usePanelStatusesDropdown = () => {
  const {
    admin: { isLogged },
  } = useAppContext();

  const { panel } = usePanel();

  const { data, error, isPending } = useQuery<PanelDropdownRespSuccess, ApiError>({
    queryKey: queryKeys.dropdowns.panel.statuses,
    queryFn: () => queryFetch({ url: 'dropdowns/tenant_statuses', panel }),
    placeholderData: (previousData) => previousData as PanelDropdownRespSuccess,
    enabled: isLogged && panel,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && isLogged && panel,
  };
};
